<template>
  <div class="container">
    <div class="details_con">
      <a-page-header
          style="padding: 0;"
          title="新闻详情"
          sub-title=""
          @back="$router.go(-1)"
      />
      <div class="title">{{info.title}}</div>
      <div class="subtitle">发表时间：{{info.releaseTime}} <span style="margin-left: 20px;">作者：{{info.author}}</span></div>
      <a-divider></a-divider>
      <div class="content" v-html="info.content"></div>
    </div>
  </div>
</template>

<script>
import {getDetails} from "../api";

export default {
  name: "NewsDetails",
  data(){
    return{
      info:''
    }
  },
  methods:{
    async getInfo(){
      const res= await getDetails({id:this.$route.params.id})
      if(res.data.status.code==200){
        this.info=res.data.result
      }
    }
  },
  created() {
    this.getInfo()
  }
}
</script>

<style lang="less" scoped>
.container{
  padding: 100px 0;
  .details_con{
    width: 1200px;
    margin: 0 auto;
    .title{
      margin-top: 20px;
      text-align: center;
      font-size: 24px;
    }
    .subtitle{
      margin-top: 10px;
      text-align: center;
      color: #999;
    }
  }
}
@media screen and (max-width: 768px){
  .container{
    padding: 60px 10px;
    .details_con{
      width: 100%;
      .title{
        font-size: 18px;
      }
      .content{
        /deep/ img{
          width: 100%;
        }
      }
    }
  }
}
</style>